const _ = "_text_1fhnj_1", c = "_underlined_1fhnj_41", l = "_ellipsis_1fhnj_44", o = {
  text: _,
  "color-primary": "_color-primary_1fhnj_14",
  "color-primary-brand": "_color-primary-brand_1fhnj_17",
  "color-secondary": "_color-secondary_1fhnj_20",
  "color-gray": "_color-gray_1fhnj_23",
  "color-success": "_color-success_1fhnj_26",
  "color-success-hover": "_color-success-hover_1fhnj_29",
  "color-error": "_color-error_1fhnj_32",
  "color-disabled": "_color-disabled_1fhnj_35",
  "color-white": "_color-white_1fhnj_38",
  underlined: c,
  ellipsis: l,
  "clamp-1": "_clamp-1_1fhnj_132",
  "clamp-2": "_clamp-2_1fhnj_139",
  "clamp-3": "_clamp-3_1fhnj_146",
  "clamp-4": "_clamp-4_1fhnj_153",
  "clamp-5": "_clamp-5_1fhnj_160",
  "clamp-6": "_clamp-6_1fhnj_167",
  "clamp-7": "_clamp-7_1fhnj_174",
  "clamp-8": "_clamp-8_1fhnj_181",
  "clamp-9": "_clamp-9_1fhnj_188",
  "clamp-10": "_clamp-10_1fhnj_195"
};
export {
  o as default,
  l as ellipsis,
  _ as text,
  c as underlined
};
//# sourceMappingURL=index.es5584.js.map
